module.exports = __webpack_public_path__ + "static/newsletter-illustration-69a96628343475f7e691ae42431e8c24.svg";